import React from "react";
import { Link } from "react-router-dom";
import { REMOVED_PUZZLE_MESSAGE } from "@/constants/playable-property-errors";

const RemovedPuzzle: React.FC = () => {
    return (
        <div className="tw-flex tw-flex-col tw-items-center tw-justify-center tw-text-center tw-min-h-[50vh] tw-px-6">
            <h1 className="tw-text-3xl tw-font-bold tw-mb-3">{REMOVED_PUZZLE_MESSAGE}</h1>
            <p className="tw-text-gray-600 tw-max-w-xl tw-mb-6">This puzzle is no longer available.</p>
            <Link
                to="/"
                className="tw-inline-flex tw-items-center tw-justify-center tw-px-5 tw-py-3 tw-rounded-full tw-bg-black tw-text-white hover:tw-bg-gray-800"
            >
                Go Back Home
            </Link>
        </div>
    );
};

export default RemovedPuzzle;
